<template>
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label class="col-form-label">{{value.isCompany ? 'Name' : 'First name'}}</label>
        <input type="text" class="form-control" v-model="value.firstName" required>
        <div class="invalid-feedback">{{value.isCompany ? 'Company name' : 'First name'}} is required.</div>
      </div>
      <div class="form-group" v-if="!value.isCompany">
        <label class="col-form-label">Last name</label>
        <input type="text" class="form-control" v-model="value.lastName" required>
        <div class="invalid-feedback">Last name is required.</div>
      </div>
      <div class="form-check form-group">
        <input class="form-check-input" @click="toggleCompany" type="checkbox" value="" :id="`isCompany${_uid}`"
               v-model="value.isCompany">
        <label class="form-check-label" :for="`isCompany${_uid}`">is a company</label>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label class="col-form-label">{{value.isCompany ? 'Address' : 'Home address'}}</label>
        <a href="javascript:" class="ask float-right" @click="toggleAddress">
          {{value.address.disabled ? 'edit' : 'ask me later'}}
        </a>
        <input type="text" class="form-control" :disabled="value.address.disabled"
               v-model="value.address.addressLine1"
               required>
        <div class="invalid-feedback">{{value.isCompany ? 'Company address' : 'Home address'}} is required.</div>
        <input type="text" class="form-control" :disabled="value.address.disabled"
               v-model="value.address.addressLine2">
      </div>
      <div class="form-group">
        <label class="col-form-label">City or location</label>
        <input type="text" class="form-control" :disabled="value.address.disabled" v-model="value.address.city"
               required>
        <div class="invalid-feedback">City or location is required.</div>
      </div>
      <div class="form-group">
        <label class="col-form-label">Post code</label>
        <input type="text" class="form-control" :disabled="value.address.disabled" v-model="value.address.postcode"
               required>
        <div class="invalid-feedback">Post code is required.</div>
      </div>
      <div class="form-group">
        <label class="col-form-label">Country</label>
        <BaseSelectCountry :disabled="value.address.disabled" v-model="value.address.country" required/>
        <div class="invalid-feedback">Country is required.</div>
      </div>
      <div class="form-check form-group" v-if="value.address.isSuggested && !value.address.disabled">
        <input class="form-check-input" type="checkbox" value="" :id="`addressCheck${_uid}`"
               v-model="value.address.confirmed" required>
        <label class="form-check-label" :for="`addressCheck${_uid}`">
          Please confirm this is their current {{value.isCompany ? '' : 'home'}} address
        </label>
        <div class="invalid-feedback">Confirmation is required.</div>
      </div>
      <p class="warning" v-show="value.address.disabled"><span class="fas fa-exclamation-triangle"></span> We will
        contact you regarding the missing information.
        Otherwise we can't successfully perform a KYB-check on your company.
      </p>
    </div>
    <div class="col-sm-4 form-group">
      <label class="col-form-label">{{value.isCompany ? 'Date of incorporation' : 'Date of birth'}}</label>
      <a href="javascript:" class="ask float-right" @click="toggleDob">
        {{value.dobDisabled ? 'edit' : 'ask me later'}}
      </a>
      <BaseSelectDate v-model="value.dateOfBirth" :initYear="parseInt(value.dobObj.year)" :initMonth="parseInt(value.dobObj.month)" :disabled="value.dobDisabled"/>
      <p class="warning" v-show="value.dobDisabled"><span class="fas fa-exclamation-triangle"></span> We will contact
        you regarding the missing information.
        Otherwise we can't successfully perform a KYB-check on your company.
      </p>
    </div>
  </div>
</template>

<script>
  import BaseSelectCountry from '@/components/BaseSelectCountry'
  import BaseSelectDate from '@/components/BaseSelectDate'

  export default {
    components: {
      BaseSelectCountry,
      BaseSelectDate
    },
    methods: {
      toggleAddress () {
        this.value.address.disabled = !this.value.address.disabled
        this.$forceUpdate()
      },
      toggleDob () {
        this.value.dobDisabled = !this.value.dobDisabled
        this.$forceUpdate()
      },
      toggleCompany () {
        this.value.isCompany = !this.value.isCompany
        this.$forceUpdate()
      }
    },
    props: {
      value: Object
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .ask {
    font-size: 14px;
    padding-top: 9px;
  }

  .warning {
    color: $yellow;
  }
</style>
